import { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  CustomContainer,
  Form,
  useDispatch,
  connect,
  useRouter,
} from "../../../atoms/DependencyHelper";
import DebitDetailsForm from "../../../atoms/newLineForms/creditCheckForms/debitDetailsForm/DebitDetailsForm";
import DebitDetailsInfo from "../../../atoms/newLineForms/creditCheckDetails/debitDetailsInfo/DebitDetailsInfo";
import CTAButton from "../../../atoms/CTAButton/CTAButton";
import WarningTitle from "../../../atoms/warningTitle/WarningTitle";
import labels from "../../../../config/labels";
import errorMessages from "../../../../config/errorMessages";
import {
  replaceDropdownKeys,
  numRegEx,
  charRegExp,
  imagePrefix,
  urlPrefix,
  durationRegex,
  showSpinner,
  hideSpinner,
  convertInToObject,
  addAutoSlashToPeriod,
  checkYearAndMonthFormat,
  generateFormURL,
  nameRegex,
} from "../../../../utils/helperServices";
import { SET_CREDIT_CHECK_DEBIT_DATA } from "../../../../Redux/actionTypes/index";
import { removeCreditCheckStates } from "../../../../Redux/actions/checkoutAction";
import microService from "../../../../utils/microServices";
import ajaxService from "../../../../utils/ajaxServices";
import Image from "../../../atoms/image/image";
import {
  ACCOUNT_TYPE_FKEY,
  ACCOUNT_TYPE_LKEY,
  ACCOUNT_TYPE,
  DEBIT_DATE_FKEY,
  BANK_NAME,
  SA_COUNTRY,
  SPP,
  FPP,
  SID,
} from "../../../../config/constants";
import formStyles from "../CheckoutCreditCheck.module.scss";
import * as Analytics from "../../../../services/analyticsUtag";
const analyticsTags = [
  "page_name",
  "page_channel",
  "page_master_tab",
  "visitor_login_status",
  "visitor_customer_id",
  "visitor_id_hash",
  "visitor_msisdn_hash",
  "visitor_subscription_type",
];

const DebitDetails = ({
  customerStatus,
  debitDetailsData,
  personalDetailsData,
  loadLookupData,
  authDetailsData,
  setShowSnackBar,
  setPageErr,
  navigate,
  onFormSubmit,
  removeCreditCheckStates,
  doCreditCheckDisable,
  multicartFlag,
}) => {
  const [analytics, setAnalytics] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [displayEditMode, setDisplayEditMode] = useState(
    debitDetailsData ? false : true
  );
  const [bankDetailsAttempt, setBankDetailsAttempt] = useState(0);
  const [displayBranchDetailsAttempt, setDisplayBranchDetailsAttempt] =
    useState(0);
  const [showWarningMsg, setShowWarningMsg] = useState(false);
  const [bankList, setBankList] = useState([]);
  const [accountType, setAccountType] = useState([]);
  const [debitOrderDate, setDebitOrderDate] = useState([]);
  const [isDisplayBranchInfo, setDisplayBranchInfo] = useState(false);
  const [monthString, setMonthString] = useState("months");
  const [yearString, setYearString] = useState("years");

  const titleContents = labels.creditCheckout.lbl_warning_contents;

  const cloneOfErrorMessages = JSON.parse(
    JSON.stringify(errorMessages.creditCheckout.errors.debit)
  );
  let sectionReference = useRef(null);
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    if (debitDetailsData) {
      fieldValues.debitDetails.bank = debitDetailsData.bank;
      fieldValues.debitDetails.accountType = debitDetailsData.accountType;
      fieldValues.debitDetails.accountNumber = debitDetailsData.accountNumber;
      fieldValues.debitDetails.initials = debitDetailsData.initials;
      fieldValues.debitDetails.surname = debitDetailsData.surname;
      fieldValues.debitDetails.duration = debitDetailsData.duration;
      fieldValues.debitDetails.ageOfAccountYears =
        debitDetailsData.ageOfAccountYears;
      fieldValues.debitDetails.ageOfAccountMonths =
        debitDetailsData.ageOfAccountMonths;
      fieldValues.debitDetails.debitOrderDate = debitDetailsData.debitOrderDate;
      fieldValues.debitDetails.debiCheckFlag = debitDetailsData.debiCheckFlag;
      errorStatus.debitDetails = checkFormError("debitDetails");

      if (errorStatus.debitDetails) {
        setSubmitDisabled(true);
      } else {
        setSubmitDisabled(false);
      }

      setState({
        ...state,
        fieldValues,
        errorStatus,
      });
    }
  }, [debitDetailsData]);

  const [state, setState] = useState({
    validationsOn: {
      debitDetails: true,
    },
    errorStatus: {
      debitDetails: true,
    },
    validations: {
      debitDetails: {
        bank: true,
        accountType: true,
        accountNumber: true,
        initials: true,
        surname: true,
        duration: true,
        ageOfAccountYears: true,
        ageOfAccountMonths: true,
        debitOrderDate: true,
        branchName: false,
        branchCode: false,
        debiCheckFlag: false,
      },
    },
    fieldErrors: {
      debitDetails: {
        bank: false,
        accountType: false,
        accountNumber: false,
        initials: false,
        surname: false,
        duration: false,
        debitOrderDate: false,
        branchName: false,
        branchCode: false,
        debiCheckFlag: false,
      },
      fail: false,
    },
    fieldValues: {
      debitDetails: {
        bank: "",
        accountType: "",
        accountNumber: "",
        initials: personalDetailsData?.initials,
        surname: personalDetailsData?.surName,
        ageOfAccountYears: "",
        ageOfAccountMonths: "",
        debitOrderDate: "",
        branchName: "",
        branchCode: "",
        debiCheckFlag: "N",
      },
    },
    fieldErrorsMessage: cloneOfErrorMessages,
  });

  const {
    validationsOn,
    errorStatus,
    validations,
    fieldErrors,
    fieldValues,
    fieldErrorsMessage,
  } = state;

  useEffect(() => {
    setBankList(
      convertInToObject(
        toGetBankList(loadLookupData?.BANK_LIST, BANK_NAME)[BANK_NAME]
      )
    );
    setAccountType(
      replaceDropdownKeys(
        sortAccountType(loadLookupData?.BANK_ACCOUNT_TYPE),
        ACCOUNT_TYPE_FKEY,
        ACCOUNT_TYPE_LKEY,
        ACCOUNT_TYPE
      )
    );
    setDebitOrderDate(
      convertInToObject(
        toGetBankList(loadLookupData?.DEBIT_ORDER_DATE, DEBIT_DATE_FKEY)[
          DEBIT_DATE_FKEY
        ]
      )
    );
  }, []);

  /**
   * Form input field change event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onChange event
   */
  const handleChange = async (event, val, form) => {
    event.persist();
    if (!analytics) {
      Analytics.link({
        ...Analytics.getUtagData([
          "page_name",
          "visitor_login_status",
          "visitor_id_hash",
          "visitor_msisdn_hash",
          "visitor_subscription_type",
        ]),
        page_form_event: "start",
        page_form_name: `checkout: credit check: ${customerStatus}: bank details`,
      });
      setAnalytics(true);
    }
    await updateFieldValues(event, val, form);
  };

  /**
   * update input field values
   *
   * @usage Set the state of fieldValues
   */
  const updateFieldValues = async (event, val, form) => {
    const name = event.target.name;
    const value = val ? val : event.target.value;
    fieldValues[form][name] = value;

    //call function to add auto slash in date field
    if (name === "ageOfAccountYears") {
      fieldValues[form][name] = addAutoSlashToPeriod(value, false, yearString);
    } else if (name === "ageOfAccountMonths") {
      fieldValues[form][name] = addAutoSlashToPeriod(value, false, monthString);
    } else if (name === "debiCheckFlag") {
      fieldValues[form][name] = event.target.checked ? "Y" : "N";
      updateDebiCheckAnalytics(event.target.checked);
    } else {
      fieldValues[form][name] = value;
    }

    setState({
      ...state,
      fieldValues,
    });
  };

  /**
   * Dropdown field reset handler
   *
   * @usage Remove the selected values
   */
  const handleReset = async (name, form) => {
    switch (name) {
      case "bank":
        fieldValues[form].bank = "";
        break;
      case "accountType":
        fieldValues[form].accountType = "";
        break;
      case "debitOrderDate":
        fieldValues[form].debitOrderDate = "";
        break;
    }
    errorStatus[form] = await checkFormError(form);
    setState({
      ...state,
      fieldValues,
      errorStatus,
    });

    if (errorStatus[form]) {
      setSubmitDisabled(true);
    } else {
      checkErrorStatus();
    }
  };

  const handleFocus = async (event, form) => {
    event.persist();
    const name = event.target.name;
    const value = event.target.value;
    if (name === "ageOfAccountYears") {
      fieldValues[form][name] = addAutoSlashToPeriod(value, false, yearString);
    } else if (name === "ageOfAccountMonths") {
      fieldValues[form][name] = addAutoSlashToPeriod(value, false, monthString);
    }
    setState({
      ...state,
      fieldValues,
    });
  };

  /**
   * Form input field blur event handler
   *
   * @usage call fieldValidationCheck function
   * @usage Set the state of form errorStatus
   * @usage Enable or disable form submit button
   * @call onBlur event
   */
  const handleBlur = async (event, val, form) => {
    event.persist();
    const name = event.target.name;
    const value = val ? val : event.target.value;
    await fieldValidationCheck(event, val, form);

    //call function to reformat MM valu on OnBlur event
    if (name === "ageOfAccountYears") {
      fieldValues[form][name] = addAutoSlashToPeriod(value, true, yearString);
    } else if (name === "ageOfAccountMonths") {
      fieldValues[form][name] = addAutoSlashToPeriod(value, true, monthString);
    }

    errorStatus[form] = await checkFormError(form);
    setState({
      ...state,
      errorStatus,
    });

    if (fieldErrors.fail) {
      setSubmitDisabled(true);
      let errMsg = fieldErrorsMessage[form][name];
      inlineAnalytics(errMsg);
    } else {
      checkErrorStatus();
    }
  };

  /**
   * Check form error status
   *
   * @usage check if form error status is true or false
   * @usage Enable or disable form submit button
   */
  function checkErrorStatus() {
    var errValues = Object.values(state.errorStatus);
    for (const err of errValues) {
      if (err) {
        setSubmitDisabled(true);
        return;
      }
    }
    setSubmitDisabled(false);
  }

  /**
   * Check input field validation
   *
   * @usage Set the state of form validations, fieldValues, fieldErrors, fieldErrorsMessage
   */
  const fieldValidationCheck = async (event, val, form) => {
    const { name } = event.target;
    const value = val ? val : event.target.value;
    switch (name) {
      case "bank":
        if (state.validationsOn[form] && state.validations[form].bank) {
          if (value?.length === 0) {
            fieldErrors[form].bank = true;
            fieldErrorsMessage[form].bank =
              state.fieldErrorsMessage.debitDetails.bank;
          } else {
            fieldErrors[form].bank = false;
          }
          fieldErrors.fail = fieldErrors[form].bank;
        } else {
          fieldErrors[form].bank = false;
        }
        break;

      case "accountType":
        if (state.validationsOn[form] && state.validations[form].accountType) {
          if (value?.length === 0) {
            fieldErrors[form].accountType = true;
            fieldErrorsMessage[form].accountType =
              state.fieldErrorsMessage.debitDetails.accountType;
          } else {
            fieldErrors[form].accountType = false;
          }
          fieldErrors.fail = fieldErrors[form].accountType;
        } else {
          fieldErrors[form].accountType = false;
        }
        break;

      case "accountNumber":
        if (
          state.validationsOn[form] &&
          state.validations[form].accountNumber
        ) {
          if (value?.length > 0) {
            if (!numRegEx.test(value)) {
              fieldErrors[form].accountNumber = true;
              fieldErrorsMessage[form].accountNumber =
                errorMessages.creditCheckout.debitDetails.accountNumber.onlyValid;
            } else {
              fieldErrors[form].accountNumber = false;
            }
          } else {
            fieldErrors[form].accountNumber = true;
            fieldErrorsMessage[form].accountNumber =
              errorMessages.creditCheckout.errors.debit.debitDetails.accountNumber;
          }
          fieldErrors.fail = fieldErrors[form].accountNumber;
        } else {
          fieldErrors[form].accountNumber = false;
        }
        break;

      case "initials":
        if (state.validationsOn[form] && state.validations[form].initials) {
          if (value?.length > 0) {
            if (!charRegExp.test(value)) {
              fieldErrors[form].initials = true;
              fieldErrorsMessage[form].initials =
                state.fieldErrorsMessage.debitDetails.initials;
            } else {
              fieldErrors[form].initials = false;
            }
          } else {
            fieldErrors[form].initials = true;
            fieldErrorsMessage[form].initials =
              state.fieldErrorsMessage.debitDetails.initials;
          }
          fieldErrors.fail = fieldErrors[form].initials;
        } else {
          fieldErrors[form].initials = false;
        }
        break;

      case "surname":
        if (state.validationsOn[form] && state.validations[form].surname) {
          if (value?.length > 0) {
            if (!nameRegex.test(value)) {
              fieldErrors[form].surname = true;
              fieldErrorsMessage[form].initials =
                state.fieldErrorsMessage.debitDetails.initials;
            } else if (value.length <= 2) {
              fieldErrors[form].surname = true;
              fieldErrorsMessage[form].initials =
                state.fieldErrorsMessage.debitDetails.initials;
            } else {
              fieldErrors[form].surname = false;
            }
          } else {
            fieldErrors[form].surname = true;
            fieldErrorsMessage[form].initials =
              state.fieldErrorsMessage.debitDetails.initials;
          }
          fieldErrors.fail = fieldErrors[form].surname;
        } else {
          fieldErrors[form].surname = false;
        }
        break;

      case "ageOfAccountYears":
      case "ageOfAccountMonths":
        if (
          state.validationsOn[form] &&
          (state.validations[form].ageOfAccountYears ||
            state.validations[form].ageOfAccountMonths)
        ) {
          if (value.length > 0) {
            if (
              checkYearAndMonthFormat(
                fieldValues[form].ageOfAccountYears,
                fieldValues[form].ageOfAccountMonths,
                true
              )
            ) {
              fieldErrors[form].duration = true;
              fieldErrorsMessage[form].duration =
                errorMessages.creditCheckout.debitDetails.duration.onlyValid;
            } else {
              fieldErrors[form].duration = false;
            }
          } else {
            fieldErrors[form].duration = true;
            fieldErrorsMessage[form].duration =
              errorMessages.creditCheckout.errors.debit.debitDetails.duration;
          }
          fieldErrors.fail = fieldErrors[form].duration;
        } else {
          fieldErrors[form].duration = false;
        }
        break;

      case "debitOrderDate":
        if (
          state.validationsOn[form] &&
          state.validations[form].debitOrderDate
        ) {
          if (value?.length === 0) {
            fieldErrors[form].debitOrderDate = true;
            fieldErrorsMessage[form].debitOrderDate =
              state.fieldErrorsMessage.debitDetails.debitOrderDate;
          } else {
            fieldErrors[form].debitOrderDate = false;
          }
          fieldErrors.fail = fieldErrors[form].debitOrderDate;
        } else {
          fieldErrors[form].debitOrderDate = false;
        }
        break;

      case "branchName":
        if (state.validationsOn[form] && state.validations[form].branchName) {
          if (value?.length === 0) {
            fieldErrors[form].branchName = true;
            fieldErrorsMessage[form].branchName =
              state.fieldErrorsMessage.debitDetails.branchName;
          } else {
            fieldErrors[form].branchName = false;
          }
          fieldErrors.fail = fieldErrors[form].branchName;
        } else {
          fieldErrors[form].branchName = false;
        }
        break;

      case "branchCode":
        if (state.validationsOn[form] && state.validations[form].branchCode) {
          if (value?.length > 0) {
            if (!numRegEx.test(value)) {
              fieldErrors[form].branchCode = true;
              fieldErrorsMessage[form].branchCode =
                errorMessages.creditCheckout.debitDetails.branchCode.onlyValid;
            } else {
              fieldErrors[form].branchCode = false;
            }
          } else {
            fieldErrors[form].branchCode = true;
            fieldErrorsMessage[form].branchCode =
              errorMessages.creditCheckout.errors.debit.debitDetails.branchCode;
          }
          fieldErrors.fail = fieldErrors[form].branchCode;
        } else {
          fieldErrors[form].branchCode = false;
        }
        break;
    }

    if (isDisplayBranchInfo) {
      validations[form].branchName = true;
      validations[form].branchCode = true;
    }

    closeSnackBar();

    setState({
      ...state,
      validations,
      fieldErrors,
      fieldValues,
      fieldErrorsMessage,
    });
  };

  /**
   *
   * @param {} message
   */
  const updateDebiCheckAnalytics = (isChecked) => {
    if (isChecked) {
      Analytics.link({
        ...Analytics.getUtagData(analyticsTags),
        page_tool_event: "use",
        page_tool_name: "checkout: credit check: consent for debicheck",
      });
    } else {
      Analytics.link({
        ...Analytics.getUtagData(analyticsTags),
        page_tool_event: "use",
        page_tool_name: "checkout: credit check: remove debicheck",
      });
    }
  };

  /**
   * Set the analytics(link)
   *
   * @call when there is any form field error occured
   */
  const inlineAnalytics = (message) => {
    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      page_form_event: "error",
      page_errors: message,
      page_form_name: `checkout: credit check: ${customerStatus}: bank details`,
      page_error_type: "form",
    });
  };

  /**
   * Set the on page edit
   *
   * @call on edit event
   */
  const setAnalyticsOnPageEdit = () => {
    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      link_type: "o",
      page_tool_event: "use",
      page_tool_name: `checkout: credit check: ${customerStatus}: edit bank details`,
    });
  };

  /**
   * Check entire form error
   *
   * @usage check if any form field value is empty or not
   * @return true/false
   */
  function checkFormError(form) {
    var values = state.fieldValues[form];
    var errors = state.fieldErrors[form];
    var entries = Object.entries(state.validations[form]);

    if (state.validationsOn[form]) {
      for (const [key, value] of entries) {
        if ((values[key] == "" && value) || errors[key]) {
          return true;
        }
      }
      return false;
    } else {
      return false;
    }
  }

  /**
   * Form submit handler
   *
   * @usage call submitForm funtion when there is no error
   * @call onSubmit event
   */
  const handleSubmit = (event) => {
    event.preventDefault();
    event.persist();
    setAnalyticsOnNextButton();

    if (!state.errorStatus["debitDetails"]) {
      submitForm();
    } else {
      displaySnackBar(
        labels.errors.lbl_form_not_submitted_fill_required,
        "form_level"
      );
      event.stopPropagation();
    }
  };

  /**
   * Form submit api call
   *
   * @usage submit the form with request payload
   */
  const submitForm = async () => {
    let newIdType = "";
    if (authDetailsData?.idType === "SAID") {
      newIdType = SID;
    } else if (authDetailsData?.idType === "PASSPORT") {
      if (authDetailsData?.countryOrigin === SA_COUNTRY) {
        newIdType = SPP;
      } else {
        newIdType = FPP;
      }
    }

    let bankName = state.fieldValues["debitDetails"].bank;
    let inputObj = {
      accountNumber: state.fieldValues["debitDetails"].accountNumber,
      accountType: state.fieldValues["debitDetails"].accountType,
      branchCode: state.fieldValues["debitDetails"].branchCode
        ? state.fieldValues["debitDetails"].branchCode
        : "",
      idCompRegNo: authDetailsData?.idNumber ? authDetailsData.idNumber : "",
      idType: newIdType,
      surnameCompName: state.fieldValues["debitDetails"].surname,
    };
    let reqParams = [bankName];

    try {
      showSpinner();

      let res = await microService.get(
        "api",
        "validateBankDetails",
        inputObj,
        false,
        reqParams
      );

      if (res.response?.data?.result) {
        if (res.response.data.result === "F") {
          setShowWarningMsg(true);

          setBankDetailsAttempt(bankDetailsAttempt + 1);
          if (bankDetailsAttempt === 0) {
            if (sectionReference.current) {
              sectionReference.current.scrollIntoView({ behavior: "smooth" });
            }
            if (multicartFlag)
              displaySnackBar(
                labels.creditCheckout.lbl_invalid_attempt_1_multicart
              );
            else displaySnackBar(labels.creditCheckout.lbl_invalid_attempt_1);
          } else if (bankDetailsAttempt === 1) {
            if (sectionReference.current) {
              sectionReference.current.scrollIntoView({ behavior: "smooth" });
            }
            displaySnackBar(labels.creditCheckout.lbl_invalid_attempt_2);
          } else if (bankDetailsAttempt === 2) {
            fetchErrorDetails(
              `captureDebitDetails_invalid`,
              "technical error",
              null,
              labels.checkout.lbl_preference_values
            );

            closeSnackBar();
            dispatch({
              type: SET_CREDIT_CHECK_DEBIT_DATA,
              payload: null,
            });
          }
        } else if (res.response.data.result === "Y") {
          setShowWarningMsg(false);
          setDisplayEditMode(false);
          doCreditCheckDisable("debitDetails", false);
          fieldValues["debitDetails"]["branchName"] =
            res.response.data.branchName;
          fieldValues["debitDetails"]["branchCode"] =
            res.response.data.branchCode;

          dispatch({
            type: SET_CREDIT_CHECK_DEBIT_DATA,
            payload: { ...state.fieldValues["debitDetails"] },
          });
          setDisplayBranchInfo(false);
          onFormSubmit(true);

          Analytics.link({
            ...Analytics.getUtagData(analyticsTags),
            page_form_event: "success",
            page_form_name: `checkout: credit check: ${customerStatus}: bank details`,
          });
        }
      } else if (res.error?.data?.result === "U" && res.error?.status === 500) {
        setDisplayBranchDetailsAttempt(displayBranchDetailsAttempt + 1);
        if (displayBranchDetailsAttempt === 0) {
          setDisplayBranchInfo(true);
          validations[type].branchName = true;
          validations[type].branchCode = true;
          setState({
            ...state,
            validations,
          });
        } else if (displayBranchDetailsAttempt === 1) {
          fetchErrorDetails(
            `captureDebitDetails_` + res.error.status,
            "technical error",
            null,
            labels.checkout.lbl_preference_values
          );
        }
      } else {
        fetchErrorDetails(
          `captureDebitDetails_` + res.error.status,
          "technical error",
          null,
          labels.checkout.lbl_preference_values
        );
      }
      hideSpinner();
    } catch (e) {
      hideSpinner();
    }
  };

  /**
   *
   * @usage open form in edit mode and set analytics on click of edit button
   */
  const clickOnEditButton = () => {
    setDisplayEditMode(true);
    doCreditCheckDisable("debitDetails", true);
    setAnalyticsOnPageEdit();
  };

  /**
   * Get the error display data
   * @usage Redirect to checkout error with error details
   */
  const fetchErrorDetails = async (
    resultCode,
    pageErrorType,
    additionalUtagData = null,
    preferences = []
  ) => {
    const pageName = `checkout: credit check: ${customerStatus}: bank details`;
    const newResultCode = multicartFlag
      ? resultCode + "_multicart"
      : resultCode;

    try {
      showSpinner();
      const result = await ajaxService.httpGet(
        "drupalBaseUrl",
        "",
        "api",
        "errorResultDetails",
        [newResultCode]
      );

      setPageErr({
        type: "error",
        title: result[0].resultTitle,
        desc:
          result[0].resultText && result[0].resultText !== ""
            ? result[0].resultText
            : result[0].resultHTML,
        primaryLabel:
          result[0].primaryEnabled === "Yes" ? result[0].primaryCTAText : null,
        primaryUrl:
          result[0].primaryCTAURL != "" ? result[0].primaryCTAURL : null,
        secondaryLabel:
          result[0].secondaryEnabled === "Yes"
            ? result[0].secondaryCTAText
            : null,
        secondaryUrl:
          result[0].secondaryCTAURL != "" ? result[0].secondaryCTAURL : null,
        handlePrimaryClick: (preferenceId) =>
          handlePrimaryClick(
            generateFormURL(
              result[0].primaryCTAURL,
              result[0].leadType,
              result[0].primaryCTAType,
              preferenceId
            ),
            result[0].primaryCTAText
          ),
        handleSecondaryClick: () =>
          handleSecondaryClick(
            generateFormURL(
              result[0].secondaryCTAURL,
              result[0].leadType,
              result[0].secondaryCTAType
            ),
            result[0].secondaryCTAText
          ),
        imgUrl: result[0].icon,
        pageName: pageName,
        pageErrorType: pageErrorType,
        additionalUtagData: additionalUtagData,
        dividerLine: multicartFlag ? true : false,
        ctaTitle: result[0].CTATitle != "" ? result[0].CTATitle : null,
        disablePrimary: multicartFlag && preferences.length > 0 ? true : false,
        preferences: multicartFlag ? preferences : [],
        defaultPreference: result[0].primaryCTAURL?.includes("/checkout")
          ? "once-off"
          : null,
      });
      hideSpinner();
      //navigate to checkout page error
      navigate("pageError");
    } catch {
      if (multicartFlag) {
        setPageErr({
          type: "error",
          title: labels.creditvetting.lbl_invalid_attempt_title,
          desc: labels.creditvetting.lbl_invalid_attempt_desc,
          primaryLabel: "Continue",
          secondaryLabel: null,
          handlePrimaryClick: (preferenceId) =>
            handlePrimaryClick(
              generateFormURL(
                "/forms/ecommerce",
                "banking_verification_check",
                "lead",
                preferenceId
              ),
              "continue"
            ),
          imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
          pageName: pageName,
          pageErrorType: pageErrorType,
          additionalUtagData: additionalUtagData,
          dividerLine: true,
          ctaTitle: labels.checkout.lbl_select_preference,
          disablePrimary: true,
          preferences: labels.checkout.lbl_preference_values,
        });
      } else {
        setPageErr({
          type: "error",
          title: labels.auth.lbl_technical_error_title,
          desc: labels.auth.lbl_technical_error_desc,
          primaryLabel: "Call me back",
          secondaryLabel: "Exit checkout",
          handlePrimaryClick: () => handlePrimaryClick(null, "call me back"),
          handleSecondaryClick: () =>
            handleSecondaryClick(null, "exit checkout"),
          imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
          pageName: pageName,
          pageErrorType: pageErrorType,
          additionalUtagData: additionalUtagData,
        });
      }
      hideSpinner();
      //navigate to checkout page error
      navigate("pageError");
    }
  };

  const handlePrimaryClick = (url, label) => {
    showSpinner();
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
      page_name: `${pageName}`,
    });

    if (url) {
      router.push(`${urlPrefix}${url}`).then(() => {
        hideSpinner();
      });
    } else {
      router.push(`${urlPrefix}/forms/ecommerce`).then(() => {
        hideSpinner();
      });
    }
  };

  const handleSecondaryClick = (url, label) => {
    showSpinner();
    const pageName = Analytics.getUtagData(["page_name"]).page_name;
    Analytics.link({
      link_type: "o",
      link_name: `${pageName}: ${label}`,
      page_name: `${pageName}`,
    });

    if (url) {
      router.push(`${url}`).then(() => {
        hideSpinner();
      });
    } else {
      router.push(`${urlPrefix}/`).then(() => {
        hideSpinner();
      });
    }
    removeCreditCheckStates(null);
  };

  /**
   * Set the on page submit
   *
   * @call on next button click
   */
  const setAnalyticsOnNextButton = () => {
    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      link_type: "o",
      link_name: `checkout: credit check: ${customerStatus}: bank details: next`,
    });
  };

  const displaySnackBar = (message, level = "page_level") => {
    setShowSnackBar({ visible: true, message: message });

    const pageAnalyticsData = {
      page_errors: message,
      page_error_type: "page",
    };

    if (level == "form_level") {
      pageAnalyticsData.page_form_event = "error";
      pageAnalyticsData.page_form_name = `checkout: credit check: ${customerStatus}: bank details`;
      pageAnalyticsData.page_error_type = "form";
    }

    Analytics.link({
      ...Analytics.getUtagData(analyticsTags),
      ...pageAnalyticsData,
    });
  };

  const closeSnackBar = () => {
    setShowSnackBar({ visible: false, message: "" });
  };

  /**
     * This function is used to saperate out bank name and create another list of array
     *
     * @usage call toGetBankList function
     
     */
  const toGetBankList = (arr, key) => {
    if (!arr.length) {
      return [];
    }
    const updatedList = {};
    arr.forEach((el) => {
      if (updatedList.hasOwnProperty(key)) {
        updatedList[key].push(el[key]);
      } else {
        updatedList[key] = [el[key]];
      }
    });
    return updatedList;
  };

  /**
   * This function is used to sort the value in asc order
   * @usage call sortAccountType function
   */
  const sortAccountType = (arr) => {
    return arr.sort((a, b) =>
      a.name.normalize().localeCompare(b.name.normalize())
    );
  };

  return (
    <>
      <CustomContainer
        className={`${formStyles["container"]}`}
        id="bank-details"
        ref={sectionReference}
      >
        <CustomContainer className={formStyles["form-heading"]}>
          {displayEditMode ? (
            <Image
              img_path={`${imagePrefix}/assets/images/icon-bank.svg`}
              img_alt="section"
              className={formStyles["section-icon"]}
            />
          ) : (
            <Image
              img_path={`${imagePrefix}/assets/images/success-circle_small.svg`}
              img_alt="success"
              className={formStyles["section-success-icon"]}
            />
          )}
          Bank account details
          {displayEditMode ? (
            <CustomContainer className={formStyles["section-numbers"]}>
              Section 5 of 7
            </CustomContainer>
          ) : (
            <CustomContainer className={formStyles["section-numbers"]}>
              <a onClick={() => clickOnEditButton()}>
                <Image
                  img_path={`${imagePrefix}/assets/images/blog.svg`}
                  img_alt="edit"
                />
                <span>Edit details</span>
              </a>
            </CustomContainer>
          )}
        </CustomContainer>
        <hr></hr>
        {displayEditMode && (
          <>
            <CustomContainer className={formStyles["section-description"]}>
              <img
                src={`${imagePrefix}/assets/images/info_teal.svg`}
                alt="tick"
              />
              <span>{labels.creditCheckout.lbl_bank_page_warning}</span>
            </CustomContainer>
            {showWarningMsg && (
              <WarningTitle
                title="Please ensure that:"
                contents={titleContents}
                className={formStyles["warning-box"]}
                id={`checkout-credit-check-warning-bank-details`}
              />
            )}
          </>
        )}
        {!displayEditMode ? (
          <DebitDetailsInfo
            data={debitDetailsData}
            accountTypes={accountType}
          />
        ) : (
          <Form
            noValidate
            id="checkout-credit-check-debit-form"
            onSubmit={handleSubmit}
          >
            <DebitDetailsForm
              formName="debitDetails"
              fieldValues={state.fieldValues["debitDetails"]}
              fieldErrors={state.fieldErrors["debitDetails"]}
              fieldErrorsMessage={state.fieldErrorsMessage["debitDetails"]}
              onChangeHandler={handleChange}
              onBlurHandler={handleBlur}
              onResetHandler={handleReset}
              onFocusHandler={handleFocus}
              bankList={bankList}
              accountTypeList={accountType}
              debitOrderDateList={debitOrderDate}
              isDisplayBranchInfo={isDisplayBranchInfo}
              multicartFlag={multicartFlag}
            />
            <CustomContainer className={formStyles["button-wrapper"]}>
              <CTAButton
                type="submit"
                variant="solid grey"
                disabled={submitDisabled}
                className={formStyles["button"]}
                id="checkout-credit-check-debit-form-submit"
              >
                Next
              </CTAButton>
            </CustomContainer>
          </Form>
        )}
      </CustomContainer>
    </>
  );
};

DebitDetails.propTypes = {
  customerStatus: PropTypes.string,
  onFormSubmit: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    debitDetailsData: state.creditCheckDetails.debitDetails,
    loadLookupData: state.checkoutDetails.lookupDetails,
    authDetailsData: state.checkoutDetails.authDetails,
    personalDetailsData: state.creditCheckDetails.personalDetails,
  };
};

const mapDispatchToProps = {
  removeCreditCheckStates,
};

export default connect(mapStateToProps, mapDispatchToProps)(DebitDetails);
